<template>
  <div class="pb-2">
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == false">
      <b-card no-body>
        <b-card-header class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">รายการลูกค้า</h4>
          <b-button variant="primary" size="sm" @click="openAddModal()">
            + เพิ่มลูกค้า
          </b-button>
        </b-card-header>
        <hr class="my-0 mx-2">
        <b-card-body>
          <div>ค้นหาโดย :</div>
          <div class="d-md-flex">
            <v-select
              class="px-0 pb-1 pb-md-0 col-12 col-md-4"
              v-model="searchID"
              :options="searchItem"
              label="text"
            ></v-select>
            <div class="px-0 px-md-1 pb-1 pb-md-0 col-12 col-md-4">
              <b-form-input v-model="searchText"/>
            </div>
            <div class="px-0 col-12 col-md-2">
              <b-button @click="getCustomer()" variant="primary">
                ค้นหา
              </b-button>
            </div>
          </div>
        </b-card-body>
        <b-card-body>
          <div class="text-right">จำนวน : {{totalRows}}</div>
          <b-table
            responsive
            :items="custmerList"
            :fields="customerFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(no)="data">
              {{(custmerList.findIndex(x => x.customerId == data.item.customerId) + 1) + ((currentPage - 1) * 10)}}
            </template>
            <template #cell(firstName)="data">
              <b-link @click="toDetail(data.item.loginToken)"><u>{{data.value}}</u></b-link>
            </template>
            <template #cell(birthDate)="data">
              {{formatDate_dmy(data.value)}}
            </template>
            <template #cell(approvedBalance)="data">
              <b-link @click="toBalance(data.item.customerId, 1)"><u>{{format_price(data.value)}}</u></b-link>
            </template>
            <template #cell(approvedYuan)="data">
              <b-link @click="toBalance(data.item.customerId, 2)"><u>{{format_price(data.value)}}</u></b-link>
            </template>
            <template #cell(actions)="data">
              <b-button size="sm" variant="outline-warning" @click="openEditModal(data.item)">
                แก้ไข
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="mt-0"
          />
        </b-card-body>
      </b-card>
    </div>

    <!-- Add / Edit Customer Modal -->
    <b-modal
      id="customerModal"
      ref="customerModal"
      @hidden="hideModal"
      title-class="h2"
      :title="isEdit ? 'แก้ไขข้อมูลลูกค้า' : 'เพิ่มลูกค้าใหม่'"
      hide-footer
      content-class="shadow"
      no-close-on-backdrop
      size="lg"
    >
      <b-form>
        <b-card-body class="py-0 px-0">
          <!-- Add Mode: minimal fields -->
          <b-row v-if="!isEdit">
            <b-col cols="12" md="6">
              <b-form-group label="ชื่อ *">
                <b-form-input v-model="form.name" placeholder="ชื่อ" />
                <span v-if="val.name === false" style="color:red">กรุณากรอกชื่อ</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Username *">
                <b-form-input v-model="form.username" placeholder="Username" />
                <span v-if="val.username === false" style="color:red">กรุณากรอก Username</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="เบอร์โทรศัพท์ *">
                <b-form-input v-model="form.phoneNumber" placeholder="0812345678" />
                <span v-if="val.phoneNumber === false" style="color:red">กรุณากรอกเบอร์โทรศัพท์</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="รหัสผ่าน *">
                <b-form-input v-model="form.password" type="password" placeholder="รหัสผ่าน" />
                <span v-if="val.password === false" style="color:red">กรุณากรอกรหัสผ่าน</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Email">
                <b-form-input v-model="form.email" type="email" placeholder="email@example.com" />
              </b-form-group>
            </b-col>
             <b-col cols="12" md="6">
              <b-form-group label="ใส่รหัสผ่านอีกครั้ง *">
                <b-form-input v-model="form.rePassword" type="password" placeholder="ใส่รหัสผ่านอีกครั้ง" />
                <span v-if="val.rePassword === false" style="color:red">กรุณาใส่รหัสผ่านอีกครั้ง</span>
                <span v-if="val.rePassword === 'mismatch'" style="color:red">รหัสผ่านไม่ตรงกัน</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Line ID">
                <b-form-input v-model="form.lineID" placeholder="Line ID" />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Edit Mode -->
          <b-row v-else>
            <b-col cols="12" md="6">
              <b-form-group label="ชื่อจริง *">
                <b-form-input v-model="form.firstName" placeholder="ชื่อจริง" />
                <span v-if="val.firstName === false" style="color:red">กรุณากรอกชื่อจริง</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="นามสกุล">
                <b-form-input v-model="form.lastName" placeholder="นามสกุล" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="ชื่อเล่น">
                <b-form-input v-model="form.nickName" placeholder="ชื่อเล่น" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Email">
                <b-form-input v-model="form.email" type="email" placeholder="email@example.com" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="เบอร์โทร *">
                <b-form-input v-model="form.phoneNumber" placeholder="0812345678" />
                <span v-if="val.phoneNumber === false" style="color:red">กรุณากรอกเบอร์โทร</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Line ID">
                <b-form-input v-model="form.lineID" placeholder="Line ID" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>

        <div class="pt-1 d-flex justify-content-end">
          <b-button variant="outline-secondary" size="sm" class="mr-1" @click="$refs['customerModal'].hide()">
            ยกเลิก
          </b-button>
          <b-button
            v-if="!isEdit"
            @click="submitAdd()"
            variant="primary"
            size="sm"
            :disabled="loadButton === false"
          >
            <b-spinner v-if="loadButton === false" small />
            เพิ่มลูกค้า
          </b-button>
          <b-button
            v-else
            @click="submitEdit()"
            variant="warning"
            size="sm"
            :disabled="loadButton === false"
          >
            <b-spinner v-if="loadButton === false" small />
            บันทึกการแก้ไข
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormGroup, BPagination, BFormInput, BButton, BCardBody, BCard, BSpinner, BRow, BCol,
  BLink, BCardHeader, BModal, BForm, BTable, BTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { formatDate_dmy, format_price } from '@/views/global_function.js'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  name: 'AdminBranchCustomer',

  components: {
    BSpinner, BCard, BCardBody, BCardHeader, BFormInput, BTable, BPagination, BLink, BTooltip,
    BButton, BModal, BForm, BFormGroup, BRow, BCol,

    vSelect,

   },

  data() {
    return {
    	userData: JSON.parse(localStorage.getItem('userData')),
      // search
      searchID: {text: 'ชื่อจริง', value: 2, req: 'customerName'},
      searchItem: [
        {text: 'ชื่อจริง', value: 2, req: 'customerName'},
        {text: 'เบอร์โทร', value: 4, req: 'phone'},
        {text: 'Email', value: 5, req: 'email'},
        {text: 'ชื่อผู้รับ', value: 6, req: 'receiverName'},
        {text: 'TaobaoID', value: 7, req: 'taobaoID'},
        {text: 'Username', value: 9, req: 'username'},
      ],
      searchText: '',

      //table
      custmerList: [],
      customerFields: [
        { key: 'no', label: 'ลำดับ', thClass: 'text-center px-0', tdClass: 'text-center px-0'},
        { key: 'firstName', label: 'ชื่อ', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'lastName', label: 'นามสกุล', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'taobaoReceiveName', label: 'Code', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'approvedBalance', label: 'เงินไทย', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'approvedYuan', label: 'เงินจีน', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'nickName', label: 'ชื่อเล่น', thClass:'text-center', tdClass: 'text-center'},
        { key: 'birthDate', label: 'วันเกิด', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'email', label: 'Email', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'phoneNumber', label: 'เบอร์โทร', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'lineID', label: 'Line ID', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'userId', label: 'Username', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'actions', label: 'จัดการ', thClass: 'text-center', tdClass: 'text-center'},
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,

      // modal
      isEdit: false,
      loadButton: true,
      form: {
        customerId: null,
        name: '',
        firstName: '',
        lastName: '',
        nickName: '',
        email: '',
        phoneNumber: '',
        lineID: '',
        username: '',
        password: '',
        rePassword: '',
      },
      val: {
        name: null,
        firstName: null,
        phoneNumber: null,
        username: null,
        password: null,
        rePassword: null,
      },

      //
      loadpage: true
    };
  },

  watch: {
    searchID() {
      console.log(this.searchID);

    },
    async currentPage() {
      await this.getCustomer()
    }
  },

  async created() {
    await this.getCustomer()
    this.loadpage = false
  },


  methods: {
    formatDate_dmy, format_price,

    async getCustomer() {
      var skip = 0
      skip = (this.currentPage - 1) * 10

      var data = {}
      if (this.searchText.trim() != '') {
        JSON.stringify(
          data[this.searchID.req] = this.searchText.trim(),
					data.branchID = this.userData.data.branchID,
          data.skip = skip,
          data.take = 10
        )
      } else {
        JSON.stringify(
					data.branchID = this.userData.data.branchID,
          data.skip = skip,
          data.take = 10
        )
      }

      let response = await axios.post(
        taobaoService_dotnet  + 'app/Branch/get-customer-list',
        data,
        { headers: header_token }
      )
      this.totalRows = response.data.totalRows
      this.custmerList = response.data.items
    },

    toDetail(token) {
      console.log(token);
      window.open("/admin/customer-detail?id=" + token);
    },

    toBalance(customerId, type) {
      const encoded = btoa(String(customerId))
      window.open("/admin-branch/customer-balance?id=" + encoded + "&type=" + type)
    },

    openAddModal() {
      this.isEdit = false
      this.resetForm()
      this.$refs['customerModal'].show()
    },

    openEditModal(item) {
      console.log(item);

      this.isEdit = true
      this.resetForm()
      this.form.customerId  = item.customerId
      this.form.firstName   = item.firstName   || ''
      this.form.lastName    = item.lastName    || ''
      this.form.nickName    = item.nickName    || ''
      this.form.email       = item.email       || ''
      this.form.phoneNumber = item.phoneNumber || ''
      this.form.lineID      = item.lineID      || ''
      this.$refs['customerModal'].show()
    },

    hideModal() {
      this.resetForm()
    },

    resetForm() {
      this.loadButton   = true
      this.form.customerId  = null
      this.form.name        = ''
      this.form.firstName   = ''
      this.form.lastName    = ''
      this.form.nickName    = ''
      this.form.email       = ''
      this.form.phoneNumber = ''
      this.form.lineID      = ''
      this.form.username    = ''
      this.form.password    = ''
      this.form.rePassword  = ''
      this.val.name         = null
      this.val.firstName    = null
      this.val.phoneNumber  = null
      this.val.username     = null
      this.val.password     = null
      this.val.rePassword   = null
    },

    validateAdd() {
      let valid = true
      this.val.name        = this.form.name.trim()        !== '' ? null : false
      this.val.phoneNumber = this.form.phoneNumber.trim() !== '' ? null : false
      this.val.username    = this.form.username.trim()    !== '' ? null : false
      this.val.password    = this.form.password.trim()    !== '' ? null : false
      if (this.form.rePassword.trim() === '') {
        this.val.rePassword = false
      } else if (this.form.password !== this.form.rePassword) {
        this.val.rePassword = 'mismatch'
      } else {
        this.val.rePassword = null
      }
      if (this.val.name === false || this.val.phoneNumber === false ||
          this.val.username === false || this.val.password === false ||
          this.val.rePassword === false || this.val.rePassword === 'mismatch') {
        valid = false
      }
      return valid
    },

    validateEdit() {
      let valid = true
      this.val.firstName   = this.form.firstName.trim()   !== '' ? null : false
      this.val.phoneNumber = this.form.phoneNumber.trim() !== '' ? null : false
      if (this.val.firstName === false || this.val.phoneNumber === false) valid = false
      return valid
    },

    async submitAdd() {
      if (!this.validateAdd()) return
      this.loadButton = false
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/sign-up',
        {
          "name": this.form.name.trim(),
          "phoneNumber": this.form.phoneNumber.trim(),
          "email": this.form.email.trim(),
          "username": this.form.username.trim(),
          "password": this.form.password.trim(),
          "lineID": this.form.lineID.trim(),
          "isNeedContact": true,
          "parentID": null,
          "branchID": this.userData.data.branchID,
        },
        { headers: header_token }
      )
      if (response.data.message == 'success') {
        this.$swal({
          icon: 'success',
          title: 'เพิ่มลูกค้าเรียบร้อย',
          confirmButtonText: 'ตกลง',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(async () => {
          this.$refs['customerModal'].hide()
          await this.getCustomer()
        })
      } else {
        this.$swal({
          icon: 'warning',
          title: 'เพิ่มลูกค้าไม่สำเร็จ',
          text: 'เนื่องจาก ' + response.data.message,
          confirmButtonText: 'เข้าใจแล้ว',
          customClass: {
            confirmButton: 'btn btn-warning',
          },
          buttonsStyling: false,
        })
      }
      this.loadButton = true
    },

    async submitEdit() {
      if (!this.validateEdit()) return
      this.loadButton = false
      try {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Branch/edit-customer-info',
          {
            "customerID": this.form.customerId,
            "firstName": this.form.firstName.trim(),
            "lastName": this.form.lastName.trim(),
            "nickName": this.form.nickName.trim(),
            "phone": this.form.phoneNumber.trim(),
            "email": this.form.email.trim(),
            "lineID": this.form.lineID.trim()
          },
          { headers: header_token }
        )
        if (response.data == "success") {
          this.$refs['customerModal'].hide()
          await this.getCustomer()
          this.$bvToast.toast('แก้ไขข้อมูลสำเร็จ', {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
          })
        }
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
        })
      } finally {
        this.loadButton = true
      }
    },
  },
};
</script>

<style scoped>

</style>
